import { createActionGroup, props } from '@ngrx/store';
import { DataSetupModel } from '@core/data-access';

export type DataSetupInitProps = { dataSetup: DataSetupModel };
export type DataSetupSuccessProps = DataSetupInitProps;

export const DataSetupActions = createActionGroup({
  source: 'DataSetup',
  events: {
    Init: props<DataSetupInitProps>(),
    'Load Success': props<DataSetupSuccessProps>(),
    'Load Failure': props<{ error: any }>(),
  },
});
